import { useApiSubmit } from '@hooks/use-api-submit';
import type { IDonorConnectSubmitResult } from '@/types/history/donor-connect';

const DONOR_CONNECT_ENDPOINT = '/api/register/donor-connect';

interface IDonorConnectResults {
    connectToDonorStatus: number | null;
}

export const useDonorConnect = (registrationId: number, editKey: string) => {
    const url = `${DONOR_CONNECT_ENDPOINT}/${registrationId}/${editKey}`;

    const toResult = (results: IDonorConnectResults) => ({ connectToDonorStatus: results?.connectToDonorStatus });

    const connect = useApiSubmit<void, IDonorConnectResults, IDonorConnectSubmitResult>(`${url}?connect=true`, () => ({}), toResult);
    const disconnect = useApiSubmit<void, IDonorConnectResults, IDonorConnectSubmitResult>(`${url}?connect=false`, () => ({}), toResult);

    const submit = (shouldConnect: boolean): Promise<IDonorConnectSubmitResult> =>
        (shouldConnect ? connect : disconnect).submit();

    return {
        submit,
        isSubmitting: connect.isSubmitting || disconnect.isSubmitting,
        submitError: connect.submitError ?? disconnect.submitError,
    };
};
